module.exports = __webpack_public_path__ + "img/100rub.75bc7fe2.png";